import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { BaseButton } from "prefab";
import { Spinner } from "@blueprintjs/core";
import intlKeyPropType from "../../utils/intlKeyPropType";
import withScopeAuth from "../hoc/withScopeAuth";
import { SCOPES } from "../../constants";
import styles from "../../styles/Button.module.scss";
import spinnerStyles from "../../styles/Spinner.module.scss";

const Message = (message) => <FormattedMessage id={message} defaultMessage={message} />;

class LocalizedButton extends Component {
  static propTypes = {
    text: intlKeyPropType.isRequired,
  };
  render() {
    const { text, url, loading, disabled, ...rest } = this.props;
    const buttonText = loading ? (
      <span className={styles.loadingContent}>
        <Spinner className={spinnerStyles.spinner} size={16} />
        {Message(text)}
      </span>
    ) : (
      Message(text)
    );
    const button = (
      <BaseButton
        buttonText={buttonText}
        {...rest}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
      />
    );
    if (url) {
      return (
        <Link to={url} scope={SCOPES.__SELF__} draggable={false}>
          {button}
        </Link>
      );
    }
    return button;
  }
}

const LocalizedButtonWithAuth = withScopeAuth(LocalizedButton);
LocalizedButtonWithAuth.defaultProps = {
  scope: SCOPES.__SELF__,
};
export default LocalizedButtonWithAuth;
